import { render, staticRenderFns } from "./ObservacaoFd.vue?vue&type=template&id=7ce03a9b&"
import script from "./ObservacaoFd.vue?vue&type=script&lang=js&"
export * from "./ObservacaoFd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports